export default {
  programId: {
    'ui:widget': 'EditorProgramIdWidget',
  },
}
